import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineBoltIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19.87 8.6A.9998.9998 0 0 0 19 8h-4.58l1.27-4.74a1.0005 1.0005 0 0 0-.17-.87 1.0005 1.0005 0 0 0-.79-.39h-7a1 1 0 0 0-1 .74l-2.68 10a.9998.9998 0 0 0 .17.87 1.001 1.001 0 0 0 .8.39h3.87l-1.81 6.74a.9999.9999 0 0 0 1.71.93l10.9-12a.9997.9997 0 0 0 .18-1.07Zm-9.79 8.68 1.07-4a1.0006 1.0006 0 0 0-.17-.87 1.0008 1.0008 0 0 0-.79-.39H6.35L8.49 4h4.93l-1.27 4.74a1.0001 1.0001 0 0 0 1 1.26h3.57l-6.64 7.28Z"/>
  </SvgIcon>
}

export default LineBoltIcon
